module.exports = __webpack_public_path__ + "static/media/OSPRERA.b1abc033.svg";